import { render, staticRenderFns } from "./PartnersManagementDetailsScreen.vue?vue&type=template&id=a6f29f40&scoped=true&"
import script from "./PartnersManagementDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./PartnersManagementDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f29f40",
  null
  
)

export default component.exports